// Sharing helpers. A phone gets its own native share sheet (Messages, WhatsApp,
// Facebook, whatever the visitor has installed); everywhere else the same
// destinations are offered as direct links plus a copy-link button.

const enc = encodeURIComponent;

export const canNativeShare = () =>
  typeof navigator !== "undefined" && typeof navigator.share === "function";

/** Hand the link to the phone's own share sheet. */
export async function shareNatively({ title, text, url }) {
  if (!canNativeShare()) return "unsupported";
  try {
    await navigator.share({ title, text, url });
    return "shared";
  } catch (error) {
    return error?.name === "AbortError" ? "cancelled" : "failed";
  }
}

/** The line that travels with every shared link. */
export const shareMessage = (title) => `${title} · Ya Tú Sabes PR`;

export const shareTargets = ({ title, text, url }) => {
  const message = [text, url].filter(Boolean).join(" ");
  return [
    { key: "whatsapp", label: "WhatsApp", href: `https://wa.me/?text=${enc(message)}` },
    { key: "facebook", label: "Facebook", href: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}` },
    { key: "x", label: "X", href: `https://twitter.com/intent/tweet?text=${enc(text || title)}&url=${enc(url)}` },
    { key: "sms", label: "SMS", href: `sms:?&body=${enc(message)}` },
    { key: "email", label: "Email", href: `mailto:?subject=${enc(title)}&body=${enc(`${text || ""}\n\n${url}`)}` },
  ];
};

export async function copyText(value) {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    // Older mobile browsers without the async clipboard API.
    try {
      const el = document.createElement("textarea");
      el.value = value;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(el);
      return ok;
    } catch {
      return false;
    }
  }
}